module.exports = __webpack_public_path__ + "img/ic_text_decrease.c2ce0e41.svg";